module.exports = __webpack_public_path__ + "img/youye3.gif";